<template>
  <div class="hello">

    <div class="footer" @scroll="footeS" ref="foot">
      <div class="title">
        <span>{{$t('language.Journalism')}}</span>
      </div>
      <div class="line_b">
        <div class="line"></div>
      </div>
      <div class="nav_tab">
        <div class="tab" :class="{active:item.isActive,isa:item.isa}" v-for="(item,index) in tabList" :key="index"
          @click="tabEvent(index,item.category_id)">
          <span>{{item.category_name}}</span>
        </div>
      </div>
      <div class="clear"></div>
      <div class="border_b"></div>
      <div class="content">
        <div class="default" v-if="journalist.length <=0">
          <img v-if="lang == 'cn'" src="../assets/image/wu.png" alt="">
          <img v-else src="../assets/image/wuE.png" alt="">
        </div>
        <div v-else class="journalismList" v-for="(item,index) in journalist" :key="index" @click="newsDetail(item.news_id)">
          <div class="journaImage" v-if="item.image != null" style="color: #FFFFFF;">
            <img :src="item.image.thumb_path" alt="">
          </div>
          <div class="journaImage" v-else style="color: #FFFFFF;">
          </div>

          <div class="journaTitle">
            <span v-if="item.title.length > 15">
              {{item.title.substr(0,15)}}...
            </span>
            <span v-else>
              {{item.title}}
            </span>
          </div>
          <div class="createTime">
            <span>{{item.create_time}}</span>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="pages">
        <el-pagination v-if="pageShow" background layout="prev, pager, next" :current-page="num" :total="total"
          @current-change="pageEvent">
        </el-pagination>
      </div>
      <div style="height: 50px;"></div>
      <div class="footerTitle" v-if="footerShow">
        <div class="title_center">
		<div class="listB" style="padding-top: 4px;padding-bottom: 4px;">
			<a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 59px;'><img src='../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a>
		</div>
          <div class="listB">
            <span>{{$t('language.address_b')}}：{{address}}</span>
          </div>
          <div class="listB">
            <span>{{$t('language.emails')}}:{{email}}</span>
          </div>
          <div class="listB">
           <a href="https://beian.miit.gov.cn/" style="color: rgba(0, 0, 0, .7);text-decoration: none;">
             <span>ICP备：晋ICP备18006634号-1</span>
           </a>
          </div>
        </div>
      </div>
      <fiex :shows="fixed" :fatherMethod="goTop"></fiex>
    </div>
  </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  export default {
    components: {
      fiex
    },
    data() {
      return {
        email: '',
        address: '',
        fixed: false,
        imageUrl: require('../assets/image/banner1.png'),
        tabList: [],
        journalist: [],
        total: 0,
        searchValues: '',
        footerShow: true,
        lang: 'cn',
        num: 1,
        pageShow: true,
        id:0,
        arr:[]
      }
    },
    created() {
      if (localStorage.getItem('languageSet') == 'zh') {
        this.lang = 'en'
      } else {
        this.lang = 'cn'
      }
      var page = 1;
      console.log(this.$route.query.page)
      if(this.$route.query.page){
        page = this.$route.query.page
        this.num = page;
      }else{
        if (localStorage.getItem('pages')) {
        page = localStorage.getItem('pages')
        this.num = page;
      } else {
        page = 1;
      }
      }

      // if (localStorage.getItem('id')) {
      //   id = localStorage.getItem('id') != 'undefined' ? localStorage.getItem('id') : 0
      // }

      this.$fetch('/news/categoryList').then(res => {

        res.data.forEach(item => {
          var obj = {};
          obj = item;
          obj.isActive = false;
          obj.isa = true;
          this.arr.push(obj);
           localStorage.setItem('ids',this.arr[0].category_id);
        })
        this.tabList = this.arr;
        if (this.tabList.length <= 0) {
          this.pageShow = false;
        }
        for (var i = 0; i < this.tabList.length; i++) {
          this.tabList[i].isActive = false;
        }
        if (localStorage.getItem('index')) {
          this.tabList[localStorage.index].isActive = true;

        } else {
          this.tabList[0].isActive = true;
        }
      })
      var data = {
        category_id:  localStorage.getItem('id') ? localStorage.getItem('id'): localStorage.getItem('ids') ? localStorage.getItem('ids') : 0,
        count: 8,
        page: page
      }
      this.$fetch('/news/list', data).then(res => {
        this.journalist = res.data.data;
        this.total = res.data.total;
      })
      this.$fetch('/index/info').then(res => {
        this.address = res.data.address;
        this.email = res.data.email;
      })
    },
    mounted() {

    },
    methods: {
      goTop() {
        this.$refs.foot.scrollTop = 0;
      },
      footeS(event) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || this.$refs.foot.scrollTop ||
          window.pageYOffset;
        if (scrollTop > 20) {
          this.fixed = true;
        } else {
          this.fixed = false;
        }
        let scrollBottom =
          event.target.scrollHeight -
          event.target.scrollTop -
          event.target.clientHeight;
        if (scrollBottom <= 0) {
          this.footerShow = true;
        } else {
          this.footerShow = false;
        }
      },
      ajaxFun(pages) {

        // pages = this.$route.query.page ? this.$route.query.page : pages;
        var that = this;
        var data = {
          category_id: localStorage.getItem('id') ? localStorage.getItem('id') : this.category_id,
          count: 8,
          page: pages
        }
        this.$fetch('/news/list', data).then(res => {
          that.journalist = res.data.data;
          this.total = res.data.total
        })
      },
      tabEvent(index, id) {
        localStorage.setItem('index', index);
        localStorage.setItem('id', id);
        for (var i = 0; i < this.tabList.length; i++) {
          this.tabList[i].isActive = false;
        }
        this.tabList[index].isActive = true;
        this.category_id = id;
        this.ajaxFun('0')
      },
      pageEvent(e) {
        window.localStorage.setItem('pages', e);
        this.ajaxFun(e)
      },
      searchEvent() {
        console.log('123')
        this.$router.push({
          path: '/search',
          query: {
            msg: this.searchValues
          }
        })
      },
      newsDetail(id) {

        this.$router.push({
          path: '/newsDetails',
          query: {
            id: id
          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/journalism.css");
</style>



// WEBPACK FOOTER //
// src/pages/Journalism.vue